import React from "react"
import ExtraAccountingForm from './Form'

export default function CreateExtraLoanAccounting() {
  return <ExtraAccountingForm isUpdate={ true } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/ExtraAccounting/Create.js